import { html } from '@genesislcap/web-core';
import type { AppManagement } from './app-management';
import { AppManagementWatchlistBondsManager } from './watchlist-bonds-manager';

AppManagementWatchlistBondsManager;

export const AppManagementTemplate = html<AppManagement>`
  <div style="height:100%;">
    <app-management-watchlist-bonds-manager
      :watchListSelectedBonds=${(x) => x.watchListSelectedBonds}>
    </app-management-watchlist-bonds-manager>
  </div>
`;
